<template>
  <v-container>
    <v-row align="start">
      <v-col v-if="imgResp.src" cols="12" md="5" xl="4" order="1" order-md="0">
        <v-img
          :aspect-ratio="aspectRatio"
          :sizes="imgResp.sizes"
          :src="imgResp.src"
          :srcset="imgResp.srcset"
          alt="Photo for training differentiator"
          contain
          max-height="480"
        />
      </v-col>

      <v-col
        v-if="value.contact_form"
        cols="12"
        md="7"
        xl="7"
        offset-xl="1"
        order="0"
        order-md="1"
      >
        <v-row
          v-if="value.contact_form.title || value.contact_form.paragraph"
          justify="center"
        >
          <v-col class="text-center">
            <TitleParagraphBlock :value="value.contact_form" />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <slot name="form" />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-if="value.title || value.paragraph"
        cols="12"
        order="2"
        order-sm="2"
      >
        <TitleParagraphCard :value="value">
          <template v-if="scrollToSection" #footer>
            <v-card-item>
              <v-btn
                class="text-none ma-1"
                color="primary"
                exact
                rounded="pill"
                size="large"
                @click="scrollToSection({ key: 'register' })"
              >
                View Schedule</v-btn
              >
            </v-card-item>
          </template>

          <template
            v-else-if="value.cta && value.cta.action && value.cta.href"
            #footer
          >
            <v-card-item>
              <v-btn
                :append-icon="mdiArrowRight"
                :href="value.cta.href"
                :target="hrefTarget(value.cta.href)"
                class="text-none ma-1"
                color="primary"
                exact
                rounded="pill"
                size="large"
              >
                {{ value.cta.action }}</v-btn
              >
            </v-card-item>
          </template>
        </TitleParagraphCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { toRef } from 'vue'
import { mdiArrowRight } from '@mdi/js'
import { useImgResponsive } from '#root/lib/img'
import { hrefTarget } from '#root/lib/utils'

const props = defineProps({
  aspectRatio: {
    default: 8 / 5,
    type: Number
  },
  scrollToSection: {
    default: undefined,
    type: Function
  },
  value: {
    required: true,
    type: Object
  }
})

const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio: props.aspectRatio,
    image: props.value.image,
    sizes: {
      md: '1600px'
    }
  }))
)
</script>
